export default __webpack_public_path__ + "static/fixedMenuWhatsappIcon-c161810da1caef8de6960da0a3c7cc2e.svg";